package net.bothosting.docs.pages.troubleshooting

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initUnknown_interactionPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("troubleshooting/unknown_interaction.md", FrontMatterElement.EmptyMap))
}

@Page("/troubleshooting/unknown-interaction")
@Layout(".components.layouts.DocsLayout")
@Composable
fun Unknown_interactionPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("unknown-interaction") }) {
        org.jetbrains.compose.web.dom.Text("Unknown Interaction")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("“Unknown Interaction”")
        }
        org.jetbrains.compose.web.dom.Text(" error generally occurs when your bot does not respond to an interaction within Discord’s required timeframe.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Discord allows your bot or application ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("up to 3 seconds")
        }
        org.jetbrains.compose.web.dom.Text(" to send an initial response. If no response is sent within this window, the interaction expires and can no longer be used, resulting in this error.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("How to prevent this:")
        }
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Always respond to interactions within 3 seconds")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("If your command needs more time to process, ")
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("defer the reply")
            }
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Deferring the response tells Discord that your bot is processing the request, giving you more time to send a final reply without triggering the error.")
    }
    com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.NOTE, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text(" Your package/module documentation might have resources regarding this error message.")
        }
    }
}
